const ROOT_PATH = `/neochat` as const;
export const ROOT = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
